import {
  LoaderThemeColor as KendoLoaderThemeColor,
  LoaderSize as KendoLoaderSize,
  LoaderType as KendoLoaderType,
} from "@progress/kendo-angular-indicators";

export declare type LoaderThemeColor = KendoLoaderThemeColor;
export declare type LoaderSize = KendoLoaderSize;
export declare type LoaderType = KendoLoaderType;
